import { BFFClient } from "services/client";
import { IListTicketsParams, ITicketsList } from "types/support-tickets";
import { BFF_HELP_CENTER_RESOURCE } from "utils/urls";

async function listTickets({
  offset = "0",
  products,
  search,
  status,
  token,
}: IListTicketsParams): Promise<ITicketsList> {
  const url = new URL(`${BFF_HELP_CENTER_RESOURCE}/support-tickets/list`);
  url.searchParams.append("offset", offset);
  if (products) {
    url.searchParams.append("products", products);
  }
  if (status) {
    url.searchParams.append("status", status);
  }

  if (search) {
    url.searchParams.append("search", search);
  }

  const endpoint = url.toString();
  const ticketsList = await BFFClient(token).get(endpoint);

  return ticketsList.data;
}

export const supportTicketsService = {
  listTickets,
};
